import React from 'react';

export function AdverseMediaLoadingStatus({ label }) {
  return <div className="kycAdverseLoadingStatus d-flex align-items-center justify-content-center w-100" role="status">
    <span className="kycAdverseDotsSlot" aria-hidden="true">
      <span className="appDotsLoader" />
    </span>
    <span>{label}</span>
  </div>;
}

export function AdverseMediaPlaceholder({ summary = false }) {
  return <div className={`kycAdversePlaceholder placeholder-glow ${summary ? 'kycAdversePlaceholder--summary' : ''}`} aria-hidden="true">
    <div className="kycAdversePlaceholderFindings">
      {!summary && <span className="placeholder rounded d-block mb-3" style={{ width: '36%', height: 13 }} />}
      {[92, 78, 86].map((width, index) => <span key={width}
        className={`placeholder rounded d-block ${index < 2 ? 'mb-2' : ''}`}
        style={{ width: `${width}%`, height: 10 }} />)}
    </div>
    {!summary && <div className="kycAdversePlaceholderIndicators">
      {[0, 1, 2, 3].map(index => <div className="d-flex align-items-center gap-3" key={index}>
        <span className="placeholder rounded" style={{ width: '38%', height: 10 }} />
        <span className="placeholder rounded flex-grow-1" style={{ height: 8 }} />
      </div>)}
    </div>}
  </div>;
}
